import { render, staticRenderFns } from "./delivery-initializer.vue?vue&type=template&id=4e49e35c&scoped=true&"
import script from "./delivery-initializer.vue?vue&type=script&lang=js&"
export * from "./delivery-initializer.vue?vue&type=script&lang=js&"
import style0 from "./delivery-initializer.vue?vue&type=style&index=0&id=4e49e35c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e49e35c",
  null
  
)

export default component.exports